"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendEventRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
const FORBIDDEN_CHANNELS_FORCE_OTA = ["prod", "beta"];
class BackendEventRequests {
    constructor(session, appInfo) {
        this.session = session;
        this.appInfo = appInfo;
        this.options = new OptionsHandler_1.OptionsHandler(this.appInfo);
    }
    createProfile(name, timeZone, channelName, address, builder) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: {
                    events: [{
                            name,
                            timeZone,
                            type: Paths_1.EventTypes.CREATE_PROFILE_V1,
                            channelName,
                            address,
                            builderId: builder === null || builder === void 0 ? void 0 : builder.builderId,
                        }],
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, this.options);
            const endpoint = this.getRootEventEndpoint();
            const response = yield (0, Utils_1.wrapFetchJson)(request, endpoint);
            return (0, Utils_1.convertIdToUUID)(response.profileId);
        });
    }
    createUser(name, email, phone, textOptIn) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: {
                    events: [{
                            type: Paths_1.EventTypes.CREATE_USER_V1,
                            name,
                            email,
                            phone,
                            textOptIn: textOptIn || false,
                        }],
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, this.options);
            const endpoint = this.getRootEventEndpoint();
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    forceOTA(channel) {
        return __awaiter(this, void 0, void 0, function* () {
            BackendEventRequests.checkForForbiddenChannels(channel);
            const options = {
                method: Paths_1.Methods.POST,
                body: {
                    events: [{
                            type: Paths_1.EventTypes.UPDATE_CHANNEL,
                            channel,
                        }],
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, this.options);
            const endpoint = this.getRootEventEndpoint();
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getRootEventEndpoint() {
        return `${this.session.baseUrl}/${Paths_1.Constants.EVENTS}`;
    }
    static checkForForbiddenChannels(channel) {
        const cleanedChannel = channel.trim().toLowerCase();
        if (FORBIDDEN_CHANNELS_FORCE_OTA.indexOf(cleanedChannel) > -1) {
            throw new Error(`${channel} can't have a force OTA applied this method`);
        }
    }
}
exports.BackendEventRequests = BackendEventRequests;
//# sourceMappingURL=BackendEventRequests.js.map